module.exports = __webpack_public_path__ + "static/media/ring.76078123.png";